<template>
  <div>
    <CollectionView :endpoint="utilities.path('communities/@/modules/support/bans', communityId)" v-model:reload="reload" default-order="createdAt:desc">
      <template v-slot:header>
        <div class="d-flex align-items-center justify-content-between">
          <h4 class="mb-0">{{ translate("bans") }}</h4>
          <ButtonView v-if="authorization.permission('modules.support.bans.edit')" type="normal" color="primary" @click="creating = true">
            {{ translate("create") }}
          </ButtonView>
        </div>
      </template>
      <template v-slot:content="{ items }">
        <div class="card">
          <div class="table-responsive">
            <div class="table">
              <div class="table-header">
                <div class="table-header-cell">{{ translate("target") }}</div>
                <div class="table-header-cell">{{ translate("created_at") }}</div>
                <div class="table-header-cell">{{ translate("actions") }}</div>
              </div>
              <div class="table-body">
                <div class="table-row" v-for="item in items" :key="item.id">
                  <div class="table-column">
                    <PlayerView :player="item.target"/>
                  </div>
                  <div class="table-column">
                    {{ utilities.formatDatetime(item.createdAt) }}
                  </div>
                  <div class="table-column">
                    <div class="d-flex align-items-center g-2">
                      <TargetedModalHttpFormView :endpoint="utilities.path('modules/support/bans/@', item.id)" method="delete" @success="reload = true">
                        <template v-slot:target="{ show }">
                          <ButtonView type="soft" color="danger" size="small" @click="show">
                            <i class="fas fa-trash"></i>
                          </ButtonView>
                        </template>
                        <template v-slot:form="{ submit, loading, hide }">
                          <SpinnerView :active="loading" color="danger"/>
                          <div class="d-flex align-items-center g-4">
                            <ButtonView type="normal" color="danger" class="w-100" @click="submit">
                              {{ translate("delete") }}
                            </ButtonView>
                            <ButtonView type="normal" color="secondary" class="w-100" @click="hide">
                              {{ translate("cancel") }}
                            </ButtonView>
                          </div>
                        </template>
                      </TargetedModalHttpFormView>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </template>
    </CollectionView>
    <ModalView v-model:active="creating">
      <template v-slot:body>
        <HttpFormView :endpoint="utilities.path('communities/@/modules/support/bans', communityId)" method="post" @success="reload = true; creating = false">
          <template v-slot:form="{ content, errors, submit, loading }">
            <div class="d-flex flex-column g-4">
              <PlayerSelectInput v-model:value="content.targetId" :endpoint="utilities.path('communities/@/modules/support/bans/players/search', communityId)" :title="translate('target')" :errors="errors.targetId" required/>
              <div class="d-flex align-items-center g-4">
                <ButtonView type="normal" color="primary" class="w-100" @click="submit">
                  {{ translate("ban") }}
                </ButtonView>
                <ButtonView type="normal" color="secondary" class="w-100" @click="creating = false">
                  {{ translate("cancel") }}
                </ButtonView>
              </div>
              <SpinnerView :active="loading" color="primary"/>
            </div>
          </template>
        </HttpFormView>
      </template>
    </ModalView>
  </div>
</template>

<script setup>
import {ButtonView, CollectionView, SpinnerView, utilities, TargetedModalHttpFormView, ModalView, HttpFormView} from "@/niftybit";
import PlayerView from "@/components/other/PlayerView.vue";
import PlayerSelectInput from "@/systems/modules/players/PlayerSelectInput.vue";
import {ref} from "vue";
import authorization from "@/authorization";

defineProps({
  communityId: String
});

const reload = ref(false);
const creating = ref(false);

</script>